const DOCUMENT_ICON_URI = 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/23835b7f-a366-4fe3-b2ee-0692abbc82c7/renditions/3b2da1d4-e32d-4323-86a2-23f2421d5ef3?binary=true';
const COBORROWER_SIGNED_TEXT = `We have received your co-borrower's disclosures. Please sign your disclosures in order to move forward with your loan.`;
const BORROWER_SIGNED_TEXT = 'Thanks for signing your disclosures. Your co-borrower still needs to sign their disclosures (sent by email) in order to move forward with the loan.';
const SIGN_YOUR_DOCUMENTS_TEXT = 'You must sign the disclosures before we can move forward with your loan.';
const SIGN_YOUR_DOCUMENTS_TITLE = `You need to sign your disclosures`;
const DOCUMENTS_SIGNED_TITLE = 'Thank you for signing your disclosures';
const CURRENT_CO_BORROWER = {
  truefalse: {
    infoText: 'Thank you for signing your disclosures! Your co-borrower will need to sign their disclosures to move forward with your loan.',
    color: '#656565',
    isDisabled: false,
    ribbonColor: '#214781',
    status: 'WAITING FOR CO-BORROWER'
  },
  falsetrue: {
    infoText: 'Please sign these disclosures, so we can move forward with your loan.',
    color: '#214781',
    isDisabled: false,
    ribbonColor: '#214781',
    status: 'SIGN DISCLOSURES'
  },
  falsefalse: {
    infoText: 'Please sign these disclosures, so we can move forward with your loan.',
    color: '#214781',
    isDisabled: false,
    ribbonColor: '#214781',
    status: 'SIGN DISCLOSURES'
  },
  truetrue: {
    infoText: undefined,
    color: '#03906A',
    isDisabled: true,
    ribbonColor: '#D1D3D4',
    status: 'COMPLETED'
  },
  true: {
    infoText: undefined,
    color: '#03906A',
    isDisabled: true,
    ribbonColor: '#D1D3D4',
    status: 'COMPLETED'
  },
  false: {
    infoText: 'Please sign these disclosures, so we can move forward with your loan.',
    color: '#214781',
    isDisabled: false,
    ribbonColor: '#214781',
    status: 'SIGN DISCLOSURES'
  }
};
const ESignConstants = {
  DOCUMENT_ICON_URI,
  COBORROWER_SIGNED_TEXT,
  BORROWER_SIGNED_TEXT,
  SIGN_YOUR_DOCUMENTS_TEXT,
  SIGN_YOUR_DOCUMENTS_TITLE,
  DOCUMENTS_SIGNED_TITLE,
  CURRENT_CO_BORROWER
};
export default ESignConstants;
//# sourceMappingURL=index.js.map